module.exports = __webpack_public_path__ + "img/05a718d16c3d487a4149c2b601a26b91.png";